// @ts-nocheck
import { useLocation, useNavigate } from 'react-router-dom';
import {
  RadarChart, PolarGrid, PolarAngleAxis, Radar, ResponsiveContainer,
  BarChart, Bar, XAxis, YAxis, Tooltip, Cell,
} from 'recharts';

interface GuestScoreResult {
  college_scores: { [cid: string]: number };
  normalized_scores: { [cid: string]: number };
  college_names: { [cid: string]: string };
}

const BAR_COLORS = ['#6366f1', '#8b5cf6', '#ec4899', '#f59e0b', '#10b981', '#06b6d4', '#ef4444', '#84cc16', '#3b82f6'];

export default function GuestResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state as GuestScoreResult | null;

  // 没有数据(直接访问或刷新丢了内存态)→ 引导重做
  if (!data || !data.normalized_scores) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md text-center">
          <p className="text-gray-600 mb-6">没有可显示的结果(自由体验结果不会保存)。</p>
          <button
            onClick={() => navigate('/guest-quiz')}
            className="bg-indigo-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-indigo-700"
          >重新体验</button>
        </div>
      </div>
    );
  }

  const names = data.college_names || {};
  // 组装图表数据,按百分比降序
  const rows = Object.keys(data.normalized_scores).map(cid => ({
    cid,
    name: names[cid] || `书院${cid}`,
    pct: data.normalized_scores[cid],
  })).sort((a, b) => b.pct - a.pct);

  const top = rows[0];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
      <div className="max-w-2xl mx-auto space-y-6 py-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          <div className="mb-2">
            <span className="inline-block text-xs bg-amber-100 text-amber-700 px-2 py-1 rounded-full">自由体验结果</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-1">你的书院性格匹配度</h1>
          {top && (
            <p className="text-gray-600 mb-4">
              与你最匹配的是 <span className="font-bold text-indigo-700">{top.name}</span>
            </p>
          )}

          {/* 雷达图 */}
          <div style={{ width: '100%', height: 320 }}>
            <ResponsiveContainer>
              <RadarChart data={rows}>
                <PolarGrid />
                <PolarAngleAxis dataKey="name" tick={{ fontSize: 12 }} />
                <Radar dataKey="pct" stroke="#6366f1" fill="#6366f1" fillOpacity={0.4} />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* 排名条形图 */}
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
          <h2 className="text-lg font-semibold text-gray-800 mb-4">匹配度排名(九个书院)</h2>
          <div style={{ width: '100%', height: 360 }}>
            <ResponsiveContainer>
              <BarChart data={rows} layout="vertical" margin={{ left: 20 }}>
                <XAxis type="number" domain={[0, 'dataMax']} tickFormatter={(v) => `${v}%`} />
                <YAxis type="category" dataKey="name" width={80} tick={{ fontSize: 12 }} />
                <Tooltip formatter={(v: unknown) => `${v}%`} />
                <Bar dataKey="pct">
                  {rows.map((_, i) => <Cell key={i} fill={BAR_COLORS[i % BAR_COLORS.length]} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-800">
          以上为性格匹配参考,不代表真实书院分配。自由体验的结果不会保存,离开本页后需要重新测试。
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => navigate('/guest-quiz')}
            className="flex-1 bg-gray-100 text-gray-700 py-3 rounded-lg font-medium hover:bg-gray-200"
          >重新体验</button>
          <button
            onClick={() => navigate('/')}
            className="flex-1 bg-indigo-600 text-white py-3 rounded-lg font-medium hover:bg-indigo-700"
          >返回首页</button>
        </div>
      </div>
    </div>
  );
}
